import { Component, Vue, Prop } from 'vue-property-decorator';
import { useEquestHome } from '@/config/app.config';
import { GetterTypes } from '@/store-vuex/types';
import moment from 'moment';
import { McsisConstants } from '@/models/constants/McsisConstants';
import { ParticipantDTO } from '@/models/ParticipantDTO';

@Component
export default class TemplateDefault extends Vue {
  @Prop({ default: '' })
  public confirmationTitle!: string;
  @Prop({ default: '' })
  public confirmationMessage!: string;

  private get participant(): ParticipantDTO {
    return this.$store.getters[GetterTypes.participant];
  }

  protected get showEquestLink(): boolean {
    return useEquestHome(this.$route.params.screening) && !this.isModified;
  }

  private get isModified(): boolean {
    return this.$store.getters[GetterTypes.isRdvModified];
  }

  private get equestRouteName(): string {
    const equest = process.env.VUE_APP_EQUEST_ROOT;
    const suName = this.$route.params.screening;
    const birthDate = moment(this.participant.birthDate!).format(McsisConstants.SwissDateFormat);
    const partId = this.participant.partId;

    return `${equest}/${suName}/at-home/identification?partId=${partId}&birthDate=${birthDate}`;
  }
}
